{
  "pt": {
    "contact": {
      "actions": {
        "accept": "Ok",
        "add": "Adicionar contacto",
        "add_type": "Adicionar {type}",
        "backInspirationLists": "Voltar às listas de inspiração",
        "cancelNew": "Anular",
        "deactivateEmployee": "Desativar",
        "deleteCustomer": "Eliminar cliente...",
        "deleteEmployee": "Eliminar membro da equipa...",
        "deleteLead": "Eliminar o lead...",
        "deletePartner": "Eliminar parceiro...",
        "delete_contact": "Eliminar",
        "edit": "Editar",
        "impersonate": "Fazer-se passar por",
        "impersonateStart": "Passe pelo portal laranja para explorar o mundo de {name}.",
        "impersonateStop": "Voltar ao seu mundo",
        "invite": "Enviar convite",
        "newTicket": "Nova conversa",
        "reactivateEmployee": "Reativar",
        "resendInvitationEmail": "Reenviar o convite por e-mail",
        "searchContact": "Pesquisar contacto",
        "searchCustomer": "Pesquisar cliente",
        "searchEmployee": "Pesquisar membro da equipa",
        "selectAll": "Selecionar todos os {total} contactos",
        "selectOption": "Selecionar opção",
        "setProfilePicture": "Definir imagem de perfil",
        "showall": "Mostrar tudo",
        "unSelectAll": "Limpar seleção."
      },
      "attributes": {
        "language": "Língua",
        "timezone": "Fuso horário",
        "title": "Título"
      },
      "labels": {
        "address": "Endereço",
        "all": "Todos os contactos",
        "back_to_overview": "Voltar à visão geral",
        "cannot_create_role": "Contacte um proprietário para criar um novo contacto",
        "cannot_delete": "Não é possível eliminar este utilizador (integração)",
        "company": "Organização",
        "company_all": "Todas as organizações",
        "contact_status": {
          "active": "Ativo",
          "added": "Ainda não foi convidado",
          "all": "Todos os estados",
          "blocked": "Desativado",
          "invited": "Convidado",
          "status": "Estado"
        },
        "contact_type": "Tipo",
        "customer": "Cliente",
        "customers": "Clientes",
        "employee": "Equipa",
        "export_contacts": "Exportar contactos",
        "general": "Geral",
        "impersonateInactiveProfile": "Esta pessoa fantástica ainda não está ativa. Ative o cliente primeiro.",
        "invite": "Sim, convidar contactos",
        "inviteProfileFirstCustomer": "Convidar primeiro o cliente para a plataforma para poder enviar mensagens, fazer-se passar por outra pessoa ou reenviar o convite por e-mail",
        "inviteProfileFirstPartner": "Convidar o parceiro para a plataforma primeiro para se fazer passar por ele ou reenviar o e-mail de convite",
        "last_login": "Último login",
        "last_seen": "visto pela última vez",
        "last_seen_not_seen_yet": "ainda não iniciou sessão",
        "lead": "Lead",
        "name": "Nome",
        "name_or_email_address": "Nome ou endereço de e-mail",
        "name_or_email_address_phone": "Nome, endereço de e-mail ou telefone",
        "noContacts": "Sem contactos",
        "no_contacts": "Não há contactos para exportar",
        "no_contacts_results": "Esta pesquisa não tem resultados. Experimente outros filtros para encontrar a pessoa certa.",
        "no_contacts_results_subtitle": "Esta pesquisa não tem resultados. Experimente outros filtros para encontrar a pessoa certa.",
        "no_contacts_results_title": "Nenhum contacto encontrado",
        "number_contacts": "Sem contactos | 1 contacto | {count} contactos",
        "other": "Outros",
        "partner": "Parceiro",
        "partners": "Parceiros",
        "project": "Projeto",
        "secondary_contact": "Contacto secundário",
        "selectOne": "Selecionar pelo menos 1 contacto",
        "selectProjectForImpersonation": "Para que projeto pretende fazer-se passar por {customer_name}?",
        "selected": "{selected} contacto selecionado. | {selected} contactos selecionados.",
        "sorting": {
          "last_name": "Nome",
          "session_started_at": "Último login",
          "status": "Estado"
        },
        "totalSelected": "Todos os {total} contactos estão selecionados.",
        "units": "Unidades"
      },
      "navigation": {
        "backToContacts": "Voltar aos contactos"
      },
      "placeholders": {
        "byNameOrEmailAddress": "Por nome ou endereço de e-mail"
      },
      "validation": {
        "emailTaken": "O endereço de e-mail é o mesmo que o anterior",
        "mustBeEmailAddress": "É necessário um endereço de e-mail válido",
        "requireEmailAddress": "E-mail necessário"
      }
    }
  }
}
